import React, { useContext } from 'react';

const HelpPage = (props) => {
    return (<>We'll be back soon.</>);
}

export default HelpPage;